import { openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue";
var _hoisted_1 = { class: "container-fluid" };
var _hoisted_2 = {
    class: "card my-5 mx-auto",
    style: { "max-width": "420px" }
};
var _hoisted_3 = { class: "card-body" };
var _hoisted_4 = {
    key: 0,
    class: "card-title"
};
var _hoisted_5 = {
    key: 1,
    class: "card-title"
};
var _hoisted_6 = { class: "mb-3" };
var _hoisted_7 = ["value"];
var _hoisted_8 = { class: "mb-3" };
var _hoisted_9 = { class: "mb-3" };
var _hoisted_10 = { class: "mb-3" };
var _hoisted_11 = { class: "input-group mb-3" };
var _hoisted_12 = { class: "mb-3" };
var _hoisted_13 = ["value"];
var _hoisted_14 = { class: "mb-3" };
var _hoisted_15 = { class: "mb-3" };
var _hoisted_16 = { class: "d-flex justify-content-between mb-3" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                (_ctx.$route.params.id === undefined)
                    ? (_openBlock(), _createElementBlock("h5", _hoisted_4, "Crear grupo o cuenta"))
                    : (_openBlock(), _createElementBlock("h5", _hoisted_5, [
                        _cache[9] || (_cache[9] = _createTextVNode("Editar el grupo ")),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.group.groupName), 1)
                    ])),
                _createElementVNode("form", {
                    onSubmit: _cache[8] || (_cache[8] = _withModifiers(
                    //@ts-ignore
                    function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        return (_ctx.submitForm && _ctx.submitForm.apply(_ctx, args));
                    }, ["prevent"]))
                }, [
                    _createElementVNode("div", _hoisted_6, [
                        _withDirectives(_createElementVNode("select", {
                            class: "form-select",
                            id: "name",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((_ctx.group.platformId) = $event); }),
                            placeholder: "Nombre",
                            required: ""
                        }, [
                            _cache[10] || (_cache[10] = _createElementVNode("option", {
                                value: null,
                                disabled: ""
                            }, "Selecciona una plataforma", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.platforms, function (pl) {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: pl.id,
                                    value: pl.id
                                }, _toDisplayString(pl.name), 9, _hoisted_7));
                            }), 128))
                        ], 512), [
                            [_vModelSelect, _ctx.group.platformId]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            id: "groupName",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((_ctx.group.groupName) = $event); }),
                            placeholder: "Nombre",
                            required: ""
                        }, null, 512), [
                            [_vModelText, _ctx.group.groupName]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            id: "email",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((_ctx.group.accountEmail) = $event); }),
                            placeholder: "Correo electrónico",
                            required: ""
                        }, null, 512), [
                            [_vModelText, _ctx.group.accountEmail]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                        _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            id: "password",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return ((_ctx.group.accountPassword) = $event); }),
                            placeholder: "Contraseña"
                        }, null, 512), [
                            [_vModelText, _ctx.group.accountPassword]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                        _cache[11] || (_cache[11] = _createElementVNode("span", { class: "input-group-text" }, "$USD", -1)),
                        _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control",
                            id: "cost",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) { return ((_ctx.group.currentCost) = $event); }),
                            placeholder: "Costo",
                            required: "",
                            step: "0.01"
                        }, null, 512), [
                            [_vModelText, _ctx.group.currentCost]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                        _withDirectives(_createElementVNode("select", {
                            class: "form-select",
                            id: "name",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) { return ((_ctx.group.status) = $event); }),
                            placeholder: "Estado",
                            required: ""
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusList, function (st) {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: st,
                                    value: st
                                }, _toDisplayString(st), 9, _hoisted_13));
                            }), 128))
                        ], 512), [
                            [_vModelSelect, _ctx.group.status]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                        _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control",
                            id: "cost",
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) { return ((_ctx.group.availableProfiles) = $event); }),
                            placeholder: "Perfiles disponibles",
                            required: ""
                        }, null, 512), [
                            [_vModelText, _ctx.group.availableProfiles]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                        _cache[12] || (_cache[12] = _createElementVNode("label", {
                            for: "banned",
                            class: "form-label"
                        }, "Fecha de baneo", -1)),
                        _withDirectives(_createElementVNode("input", {
                            type: "date",
                            class: "form-control datepicker",
                            id: "banned",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) { return ((_ctx.group.bannedAt) = $event); })
                        }, null, 512), [
                            [_vModelText, _ctx.group.bannedAt]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_router_link, {
                            to: "/admin/groups",
                            class: "btn btn-link"
                        }, {
                            default: _withCtx(function () { return _cache[13] || (_cache[13] = [
                                _createTextVNode("Cancelar")
                            ]); }),
                            _: 1
                        }),
                        _cache[14] || (_cache[14] = _createElementVNode("button", {
                            type: "submit",
                            class: "btn btn-primary"
                        }, "Guardar", -1))
                    ])
                ], 32)
            ])
        ])
    ]));
}
